/**
 * What was tapped last in the page, for what it asks next to come from (a native app's confirmation growing from it):
 * the button, link or item touched, or what stood for it (a menu's button, its menu gone once an item's chosen).
 */
let last: Element | null = null;

if (typeof document !== "undefined") {
  document.addEventListener(
    "pointerdown",
    (e) => {
      const target = e.target instanceof Element ? e.target : null;
      last = target?.closest("button, a, [role=menuitem], summary, label") ?? target;
    },
    { capture: true },
  );
}

/** `el` as what was tapped last. */
export function tapped(el: Element | null): void {
  last = el;
}

/** Where what was tapped last is, in the viewport (none: it isn't shown anymore). */
export function anchor(): { x: number; y: number; width: number; height: number } | null {
  const r = last?.isConnected ? last.getBoundingClientRect() : null;
  return r && (r.width > 0 || r.height > 0) ? { x: r.x, y: r.y, width: r.width, height: r.height } : null;
}
